import React, {useEffect, useState} from 'react';
import axios from "axios";
import {
    Box,
    Button,
    HStack,
} from "@chakra-ui/react";
import { SecureIframe } from './components/SecureIframe';


const Customer: React.FC = () => {
    const baseUrl = process.env.REACT_APP_RESERVE_BASE_URL;
    const [src, setSrc] = useState(`${baseUrl}/shop_manager/customer`);

    const menu = [
        { label: "顧客一覧", url: `${baseUrl}/shop_manager/customer` },
        { label: "属性管理", url: `${baseUrl}/shop_manager/properties` },
    ];

    return (
        <Box
            transform="scale(0.8)"
            transformOrigin="top left"
            width="125%"   // 1 / 0.8 = 1.25 → 見切れ防止
            height="125%"
        >
        <HStack spacing={4} mb={4} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
                {menu.map((item) => (
                    <Button
                        key={item.label}
                        onClick={() => setSrc(item.url)}
                        colorScheme="blue"
                        variant="outline"
                    >
                        {item.label}
                    </Button>
                ))}
            </HStack>
            <SecureIframe src={src} />
        </Box>
    );
};

export default Customer;